import { render, staticRenderFns } from "./Fuerza.vue?vue&type=template&id=11192051&"
import script from "./Fuerza.vue?vue&type=script&lang=js&"
export * from "./Fuerza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports